import styled from 'styled-components';

export const StyledSelect = styled.select`
  font-family: 'Source Sans Pro', sans-serif;
`;
